import { Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssetUsers } from "app/_models/user-model";
import { UserStatus } from "app/_models/user-status";
import { AdminService } from "app/_services/admin.service";
import { AssetUserService } from "app/_services/asset-user.service";
declare const swal: any;

export function customEmailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const email = control.value;
  const emailPattern = /^[a-z0-9._%+-]+@tsiplc\.com$/;

  if (!email) return null;

  if (email.length > 50) {
    return { invalidEmail: "Email must be 50 characters or fewer." };
  }

  if (!emailPattern.test(email)) {
    return {
      invalidEmail: "Please enter a valid lowercase @tsiplc.com email address.",
    };
  }

  return null;
}

@Component({
  selector: "app-update-asset-user",
  templateUrl: "./update-asset-user.component.html",
  styleUrls: ["./update-asset-user.component.css"],
})
export class UpdateAssetUserComponent implements OnInit {
  editAssetUserForm: FormGroup;
  editAssetUser: AssetUsers;
  pageNumber: number;
  pageSize: number;
  searchValue: string;
  userStatus: UserStatus[] = [];

  constructor(
    private readonly assetUserService: AssetUserService,
    private readonly adminService: AdminService,
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<UpdateAssetUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editAssetUser = JSON.parse(JSON.stringify(data.assetUserDetail));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.searchValue = data.searchValue;
  }
  ngOnInit(): void {
    this.editAssetUserForm = this.fb.group({
      employeeId: [
        this.editAssetUser.employeeId,
        [
          Validators.required,
          Validators.pattern("^\\s*[a-zA-Z0-9]+\\s*$"),
          Validators.maxLength(20),
        ],
      ],
      firstName: [
        this.editAssetUser.firstName,
        [
          Validators.required,
          Validators.pattern("^(?![ .]+$)([a-zA-Z]+[ .]*)*$"),
          Validators.maxLength(20),
        ],
      ],
      lastName: [
        this.editAssetUser.lastName,
        [
          Validators.required,
          Validators.pattern("^(?![ .]+$)([a-zA-Z]+[ .]*)*$"),
          Validators.maxLength(20),
        ],
      ],
      email: [
        this.editAssetUser.email,
        [Validators.required, customEmailValidator],
      ],
      mobileNumber: [
        this.editAssetUser.mobileNumber,
        [
          Validators.required,
          Validators.pattern("^[0-9]{10}$"), // Exactly 10 digits, only numbers
        ],
      ],
      appStatusId: [this.editAssetUser.appStatusId, [Validators.required]],
    });
     this.getUserStatus();
  }

    getUserStatus() {
    this.adminService.getUserStatus().subscribe((result) => {
      this.userStatus = result;
    });
  }
  updateAssetUser() {
    let model = {
      assetUserId: this.editAssetUser.assetUserId,
      employeeId: this.editAssetUserForm.value.employeeId,
      firstName: this.editAssetUserForm.value.firstName,
      lastName: this.editAssetUserForm.value.lastName,
      email: this.editAssetUserForm.value.email,
      mobileNumber: this.editAssetUserForm.value.mobileNumber,
      appStatusId: this.editAssetUserForm.value.appStatusId,
    };
    this.assetUserService.updateAssetUser(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          let result = {
            searchValue: this.searchValue,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        }
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  close()
  {
      let result = {
      searchValue: this.searchValue,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }


}
